module.exports = __webpack_public_path__ + "mt.93f3f23ed8f38bb1b9e0.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/mt.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/mt.svg
// module chunks = styles